import { Component, OnInit, Input } from '@angular/core';
import { RiskService } from 'app/risk/risk.service';
import { TokenService } from 'app/token/token.service';

@Component({
  selector: 'zest-declined-card',
  templateUrl: './declined-card.component.html',
  styleUrls: ['./declined-card.component.scss']
})
export class DeclinedCardComponent implements OnInit {

  @Input() code: string;

  declinedReason: string;

  constructor(
    private riskService: RiskService,
    private tokenService: TokenService
  ) { }

  ngOnInit() {
    this.getRejectionCodes(this.code);
  }

  getRejectionCodes(code) {
    this.riskService.getRiskErrorCodes().subscribe(codes => {
      if (!code) {
        code = this.tokenService.getRiskStatusCode();
      }
      this.declinedReason = code ? codes[code] : '';
    });
  }
}
